module.exports = __webpack_public_path__ + "img/loading.96dd15b4.png";